import { FC } from 'react';
import { ACTOR_INFO } from '../../constants/conversation';
import { useConversation } from '../../contexts/conversation';
import { ActorType } from '../../enums/conversation';
import Header from '../Header';

const ChatHeader: FC = () => {
    const { conversation } = useConversation();
    const { lastAssignedAgentName: agentName } = conversation?.metaData || {};

    const navTitle =
        conversation?.isAgentActive && agentName && typeof agentName === 'string'
            ? `Chat with ${agentName.trim().split(' ')[0]}`
            : `Chat with ${ACTOR_INFO[ActorType.BOT].name}`;

    return <Header navTitle={navTitle} />;
};

export default ChatHeader;
